import React, { Component } from "react";
import { connect } from "react-redux";
import T from "prop-types";
import {
  CurrencyField,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import { Button } from "react-bootstrap";
import { useCurrentUser } from "APP_ROOT/hooks";
import { ACCOUNTING, ADMIN } from "MODULES/users/constants";
import * as actions from "../../actions";

const FORM_NAME = "updateCommissionOverrideForm";
class UpdateStatusForm extends Component {
  render() {
    const { close } = this.props;

    const currentUser = useCurrentUser();

    if (![ADMIN, ACCOUNTING].includes(currentUser.role)) {
      return null;
    }

    return (
      <div>
        <AppForm {...this.props}>
          <AppForm.Body>
            <CurrencyField
              inputProps={{
                min: undefined
              }}
              name="overridden_value"
              label="Override Commission"
            />
          </AppForm.Body>
          <AppForm.Footer>
            <Button onClick={close}>Cancel</Button>
            <Button type="submit" bsStyle="primary">
              Save
            </Button>
          </AppForm.Footer>
        </AppForm>
      </div>
    );
  }
}

UpdateStatusForm.propTypes = {
  commission: T.shape({
    id: T.number
  }).isRequired,
  close: T.func.isRequired,
  errorMessages: T.shape({}),
  submitFailed: T.bool,
  update: T.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => dispatch(actions.update(ownProps.commission.id, data))
}))(
  form({
    form: FORM_NAME
  })(UpdateStatusForm)
);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/Search/UpdateCommissionForm.jsx